import type { DtfArtworkPricing } from "@design-lab/entities/transfers-lab/api/types";

type PricingDisplayProps = {
  pricing: DtfArtworkPricing | null | undefined;
  isLoading: boolean;
  quantity: number;
};

export function PricingDisplay({ pricing, isLoading, quantity }: PricingDisplayProps) {
  // Don't show price when quantity is 0
  if (quantity <= 0) {
    return null;
  }

  // Loading state - show old price greyed out or loading text
  if (isLoading) {
    return (
      <span className="text-gray-400">
        {pricing?.retailPriceTotal ? `$${pricing.retailPriceTotal}` : "Loading..."}
      </span>
    );
  }

  // Show current price
  if (pricing?.retailPriceTotal) {
    return <span className="font-medium text-gray-700">${pricing.retailPriceTotal}</span>;
  }

  // No price available
  return <span className="text-gray-400">-</span>;
}
